// removed by extract-text-webpack-plugin
module.exports = {"checkboxContainer":"AutoCompleteCity__checkboxContainer___2WTaH","sectionSubtitle":"AutoCompleteCity__sectionSubtitle___3DLy3","addText":"AutoCompleteCity__addText___2En20","divider":"AutoCompleteCity__divider___39pNO","noteText":"AutoCompleteCity__noteText___13RIe","item":"AutoCompleteCity__item___3XRnn","itemPadding":"AutoCompleteCity__itemPadding___3Koqe"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/completeProfile/components/AutoCompleteCity.scss
// module id = 1758
// module chunks = 0